import {
  Target,
  Droplets,
  BarChart3,
  ArrowLeftRight,
  ClipboardCheck,
  Shield,
  UserPlus,
  Database,
  LineChart,
} from 'lucide-react'

export const features = [
  { key: 'goalPlanning', icon: Target },
  { key: 'liquidity', icon: Droplets },
  { key: 'budget', icon: BarChart3 },
  { key: 'payments', icon: ArrowLeftRight },
  { key: 'control', icon: ClipboardCheck },
  { key: 'starug', icon: Shield },
] as const

export const steps = [
  { key: 'step1', icon: UserPlus, number: 1 },
  { key: 'step2', icon: Database, number: 2 },
  { key: 'step3', icon: LineChart, number: 3 },
] as const

export const teamMembers = [
  { key: 'ingo', initials: 'IB' },
] as const

// Testimonials data
export const testimonials = [
  { key: 'testimonial1' },
  { key: 'testimonial2' },
  { key: 'testimonial3' },
] as const

export const trustStats = [
  { key: 'compliance', value: '100%' },
  { key: 'timeSaved', value: '20+' },
  { key: 'protection', value: '360°' },
] as const

export const navLinks = [
  { key: 'features', href: '#features' },
  { key: 'howItWorks', href: '#how-it-works' },
  { key: 'pricing', href: '#pricing' },
  { key: 'team', href: '#team' },
  { key: 'contact', href: '#contact' },
] as const
